import React, { ChangeEvent, ReactNode, VFC } from 'react';
import styled from 'styled-components';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { INDICATOR_COLOR } from '~/src/admin/components/People/constants';
import { Person } from '~/src/core/People/types';

const Indicator = styled.span`
  border-style: solid;
  border-width: 0 12px 16px 12px;
  border-color: transparent transparent ${INDICATOR_COLOR} transparent;
`;

const useStyles = makeStyles((theme: Theme) => ({
  appBar: {
    backgroundColor: 'transparent',
    zIndex: theme.zIndex.appBar - 10,
  },
  tabs: {
    width: '100%',
  },
  indicator: {
    backgroundColor: 'transparent',
    height: '20px',
    display: 'flex',
    justifyContent: 'center',
    position: 'inherit',
  },
}));

interface Props {
  tabValue: number;
  selectedPeople: Array<Person>;
  onChangeTab: (event: ChangeEvent<HTMLInputElement>, value: number) => void;
  loaded: boolean;
  children: ReactNode;
}

const PeopleTabs: VFC<Props> = ({ tabValue, onChangeTab, children }) => {
  const classes = useStyles();

  return (
    <AppBar
      position="static"
      elevation={0}
      component="div"
      className={classes.appBar}
    >
      <Tabs
        value={tabValue || 0}
        onChange={onChangeTab}
        aria-label="people tabs"
        variant="scrollable"
        selectionFollowsFocus
        classes={{
          root: classes.tabs,
          indicator: classes.indicator,
        }}
        TabIndicatorProps={{
          children: <Indicator />,
        }}
      >
        {children}
      </Tabs>
    </AppBar>
  );
};

export default PeopleTabs;
